import React from 'react';
import swal from 'sweetalert';
import i18n from '../../../../i18n';
import { getOrganizationList } from '../../../../models/organization';
import { getGroupsList } from '../../../../models/groups';
import { SideBar } from '../../sidebar';
import Select from 'react-select';
import { getWalletUsers } from '../../../../models/users';
import Dropdown from '../../../common/DropDown';
import { selectStyles } from '../../../../styles/components/js/selectStyle';
import { auctionRefund, getPaymentsByType } from '../../../../models/payments';
import { PaymentsList } from '../../../refund/refundList';
import NoData from '../../../common/NoData';
import { TableSkeleton } from '../../../common/skelton/TableSkelton';
import { WarningBox } from '../../../common/WarningBox';
import { ConfirmModal } from '../../../common/ConfirmModal';
import { User, Mail, Phone, CreditCard, FileText } from 'lucide-react';
import StatusTabs from '../../../common/StatusTab';
import FilterSection from '../../../common/Filter';
import HeaderBanner from '../../../common/HeaderBanner';

export class Refund extends React.Component {
  constructor() {
    super();
    this.state = {
      search: {
        type: 'enroll',
        payment: '',
        client: '',
        group: '',
        bidder: null,
      },
      refundStatus: 'pending',
      input: {},
      clients: [],
      groups: [],
      customers: [],
      payments: [],
      selectedIds: [],
      selectedUser: {},
      showUserPopUp: false,
      statusData: [
        { key: 'pending', label: 'Pending', count: 0 },
        { key: 'completed', label: 'Completed', count: 0 },
        { key: 'rejected', label: 'Rejected', count: 0 },
      ],
      is_loading: false,
      limit: 15,
      page: 1,
      rejectNote: null,
      rejectNoteError: null,
    };

    this.handleSearchChange = this.handleSearchChange.bind(this);
  }
  componentDidMount() {
    window.scrollTo(0, 0);
    // Parse URL query params
    const params = new URLSearchParams(window.location.search);
    const search = {
      type: params.get('type') || 'enroll',
      payment: params.get('payment') || '',
      client: params.get('client') || '',
      group: params.get('group') || '',
      bidder: params.get('bidder') || null,
    };
    const refundStatus = params.get('refundStatus') || 'pending';
    const page = parseInt(params.get('page')) || 1;
    const limit = parseInt(params.get('limit')) || 15;

    this.setState({ search, refundStatus, page, limit }, () => {
      this.getAllOrganization?.();
      this.getBidders?.();
      this.getPayments();
    });
  }

  // Update URL without refreshing page
  updateUrlQuery(q) {
    const queryString = new URLSearchParams(
      Object.fromEntries(Object.entries(q).filter(([_, v]) => v !== '' && v !== null))
    ).toString();
    window.history.replaceState(null, '', `${window.location.pathname}?${queryString}`);
  }
  async getPayments() {
    this.setState({ is_loading: true, selectedIds: [] });
    let { limit, page, refundStatus } = this.state;
    let { type, payment, group, client, bidder } = this.state.search;
    if (!type) {
      return;
    }
    const q = {
      page: page,
      limit: limit,
      type: type,
    };
    if (payment) q.payment = payment;
    if (group) q.group = group;
    if (client) q.client = client;
    if (refundStatus) q.refundStatus = refundStatus;
    if (bidder) q.bidder = bidder;

    // Update URL
    this.updateUrlQuery(q);

    let response = await getPaymentsByType(q);
    if (response.success) {
      let payments = response.data;
      let { total, pendingCount, completedCount, rejectedCount } = response.meta;
      this.setState({
        payments,
        total,
        statusData: [
          { key: 'pending', label: 'Pending', count: pendingCount },
          { key: 'completed', label: 'Completed', count: completedCount },
          { key: 'rejected', label: 'Rejected', count: rejectedCount },
        ],
        is_loading: false,
      });
    }
    this.setState({ is_loading: false });
  }
  async getAllOrganization() {
    const response = await getOrganizationList();
    let clients = response.data;
    this.setState({ clients });
  }

  async getBidders() {
    this.setState({ bidder_loading: true });
    const response = await getWalletUsers();
    let data = response.data;
    if (response.success) {
      const customers = data.map((item) => {
        return {
          value: item.id,
          label: item.name + ' (' + item.username + ')',
        };
      });

      this.setState({ bidder_loading: false });
      this.setState({ customers: customers });
    } else {
      this.setState({ bidder_loading: false });
    }
  }

  async getAllGroups() {
    this.setState({ group_loading: true });
    let { client } = this.state.search;
    let q = client ? `organization=${client}` : '';
    const response = await getGroupsList(q);
    if (response.success) {
      let groups = response.data;
      this.setState({ groups });
      this.setState({ group_loading: false });
    } else {
      this.setState({ group_loading: false });
    }
  }

  handleTabChange = (key) => {
    this.setState({ refundStatus: key }, () => {
      this.getPayments();
    });
  };

  handleSearchChange = (e) => {
    const { name, value } = e.target;
    this.setState(
      (prevState) => {
        const updatedSearch = { ...prevState.search, [name]: value };
        return { search: updatedSearch };
      },
      () => {
        if (name === 'client') {
          this.getAllGroups();
        }
      }
    );
  };

  handleSearch = () => {
    this.getPayments();
  };

  handleClear = () => {
    const defaultSearch = {
      type: 'enroll',
      payment: '',
      client: '',
      group: '',
      bidder: null,
      refundStatus: this.state.refundStatus,
    };

    this.setState({ search: defaultSearch, groups: [], page: 1, selectedIds: [] }, () => {
      this.updateUrlQuery({ page: 1, limit: this.state.limit, type: 'enroll' });
      this.getPayments();
    });
  };

  onChangePage = (page) => {
    this.setState({ page: page }, () => {
      this.getPayments();
    });
  };

  onChangeRowsPerPage = (limit) => {
    this.setState({ limit: limit, page: 1 }, () => {
      this.getPayments();
    });
  };

  handleCheckboxChange = (row) => {
    this.setState((prev) => {
      const selectedIds = prev.selectedIds.includes(row.id)
        ? prev.selectedIds.filter((id) => id !== row.id)
        : [...prev.selectedIds, row.id];
      return { selectedIds };
    });
  };

  handleCheckAll = (payments) => {
    const eligibleIds = payments.filter((r) => !r.refund_not_eligible).map((r) => r.id);
    this.setState((prev) => {
      const allSelected = prev.selectedIds.length === eligibleIds.length;
      return { selectedIds: allSelected ? [] : eligibleIds };
    });
  };

  handleApprove = () => {
    this.setState({
      showConfirm: true,
      confirmAction: 'approve',
    });
  };

  handleReject = () => {
    this.setState({
      showConfirm: true,
      confirmAction: 'reject',
    });
  };

  handleConfirm = async () => {
    const { confirmAction, selectedIds, rejectNote, search } = this.state;
    if (confirmAction === 'reject' && (!rejectNote || rejectNote.trim() === '')) {
      this.setState({ rejectNoteError: 'Reject note is required.' });
      return;
    }
    const payload = {
      type: search.type,
      ids: selectedIds,
      status: confirmAction === 'approve' ? 'PA' : 'RR',
      reject_reason: rejectNote,
    };
    this.setState({ action_loading: true });

    try {
      const response = await auctionRefund(payload);

      if (response.success) {
        swal({
          title: 'Success',
          text: `Refund ${confirmAction === 'approve' ? 'approved' : 'rejected'} successfully`,
          icon: 'success',
          buttons: false,
          timer: 2000,
        });

        // Clear selected IDs only after success
        this.setState({
          action_loading: false,
          showConfirm: false,
          confirmAction: null,
          selectedIds: [],
          rejectNote: null,
          rejectNoteError: null,
        });

        // Refresh payments
        this.getPayments();
      } else {
        swal({
          title: 'Failed',
          text: response.message || 'Failed to update refund process',
          icon: 'error',
          buttons: false,
          timer: 2000,
        });
        this.setState({ action_loading: false });
      }
    } catch (error) {
      swal({
        title: 'Error',
        text: 'Something went wrong',
        icon: 'error',
        buttons: false,
        timer: 2000,
      });
      this.setState({ action_loading: false });
    }
  };

  handleCancel = () => {
    this.setState({
      showConfirm: false,
      confirmAction: null,
      selectedIds: [],
      rejectNote: null,
      rejectNoteError: null,
    });
  };

  render() {
    const { clients, groups, group_loading, customers, refundStatus, selectedIds } = this.state;

    return (
      <React.Fragment>
        <HeaderBanner
          title={i18n.t('auction_refund')}
          // subtitle={i18n.t('track_your_successful_bid')}
        />
        <section className="mt-5">
          <div className="container">
            <div className="row">
              <div className="col-xl-3 col-lg-12 col-md-12">
                {!this.state.hideSidebar && <SideBar />}
              </div>
              <div
                className={
                  this.state.hideSidebar
                    ? 'col-xl-12 col-lg-12 col-md-12'
                    : 'col-xl-9 col-lg-12 col-md-12'
                }
              >
                <div className="card">
                  <div className="card-header">
                    <div className="expand-dashboard">
                      <span
                        style={{ fontSize: '1rem', marginRight: '0.5rem', cursor: 'pointer' }}
                        onClick={() => {
                          this.setState({
                            hideSidebar: !this.state.hideSidebar,
                          });
                        }}
                      >
                        {this.state.hideSidebar && <i className="icon-size-actual"></i>}
                        {!this.state.hideSidebar && <i className="icon-size-fullscreen"></i>}
                      </span>
                    </div>
                  </div>
                  <div className="card-body">
                    <StatusTabs
                      tabs={this.state.statusData}
                      onTabChange={this.handleTabChange}
                      selected={this.state.refundStatus}
                    />
                    <FilterSection
                      loading={this.state.is_loading}
                      onSearch={this.handleSearch}
                      onClear={this.handleClear}
                    >
                      {/* Type Dropdown */}
                      <Dropdown
                        name="type"
                        value={this.state.search.type}
                        onChange={this.handleSearchChange}
                        placeholder={i18n.t('type')}
                        empty={i18n.t('select_type')}
                        options={[
                          { value: 'enroll', label: i18n.t('enroll') },
                          { value: 'site_visit', label: i18n.t('site_visit') },
                        ]}
                      />

                      {/* Payment Type Dropdown */}
                      <Dropdown
                        name="payment"
                        value={this.state.search.payment}
                        onChange={this.handleSearchChange}
                        placeholder={i18n.t('payment')}
                        empty={i18n.t('select_payment')}
                        options={[
                          { value: 'online', label: i18n.t('online') },
                          { value: 'offline', label: i18n.t('offline') },
                          { value: 'wallet', label: i18n.t('wallet') },
                        ]}
                      />

                      {/* Client Dropdown */}
                      <Dropdown
                        name="client"
                        value={this.state.search.client}
                        onChange={this.handleSearchChange}
                        placeholder={i18n.t('client_name')}
                        empty={i18n.t('select_client')}
                        options={clients.map((c) => ({ value: c.id, label: c.organization_name }))}
                      />

                      {/* Group Dropdown */}
                      <Dropdown
                        name="group"
                        value={this.state.search.group}
                        onChange={this.handleSearchChange}
                        placeholder={
                          group_loading ? `${i18n.t('loading')}...` : i18n.t('auction_group')
                        }
                        empty={i18n.t('select_auction')}
                        options={groups.map((g) => ({ value: g.id, label: g.group_name }))}
                        disabled={group_loading}
                      />
                      {/* Bider Dropdown */}
                      <div className="react-select-wrapper">
                        <Select
                          options={customers}
                          value={
                            customers.find((c) => c.value === this.state.search.bidder) || null
                          }
                          onChange={(selectedOption) => {
                            this.setState((prevState) => ({
                              search: {
                                ...prevState.search,
                                bidder: selectedOption ? selectedOption.value : null,
                              },
                            }));
                          }}
                          name="bidder"
                          styles={selectStyles}
                          menuPlacement="auto"
                          menuPortalTarget={document.body}
                          placeholder="Search Bidder"
                          className=""
                        />
                        {/* Only show label when there's a selected value */}

                        <label className="react-select-label">Bidder</label>
                      </div>
                    </FilterSection>
                    {refundStatus === 'pending' && selectedIds.length > 0 && (
                      <WarningBox
                        data={this.state.selectedIds}
                        onApprove={(item) => this.handleApprove(item)}
                        onReject={(item) => this.handleReject(item)}
                      />
                    )}

                    <div className="Data-Listing">
                      {this.state.is_loading ? (
                        <TableSkeleton columns={6} rows={10} />
                      ) : this.state.payments.length ? (
                        <PaymentsList
                          type={'enroll'}
                          payments={this.state.payments}
                          isLoading={this.state.is_loading}
                          pendingTab={this.state.refundStatus === 'pending'}
                          selectedIds={this.state.selectedIds}
                          onCheckboxChange={this.handleCheckboxChange}
                          onCheckAll={this.handleCheckAll}
                          currentPage={this.state.page}
                          limit={this.state.limit}
                          total={this.state.total}
                          onChangePage={this.onChangePage}
                          onChangeRowsPerPage={this.onChangeRowsPerPage}
                          showUserInfo={(user) => {
                            this.setState({
                              selectedUser: user,
                              showUserPopUp: true,
                            });
                          }}
                        />
                      ) : (
                        <NoData
                          message="No payments available"
                          actionText={i18n.t('refresh')}
                          onAction={this.getPayments.bind(this)}
                        />
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        <ConfirmModal
          show={this.state.showConfirm}
          onClose={this.handleCancel}
          title={
            this.state.confirmAction === 'approve' ? 'Approve Confirmation' : 'Reject Confirmation'
          }
          message={
            this.state.confirmAction === 'approve'
              ? 'Are you sure you want to approve this item?'
              : 'Are you sure you want to reject this item?'
          }
          onConfirm={this.handleConfirm}
          onCancel={this.handleCancel}
          confirmText={this.state.confirmAction === 'approve' ? 'Approve' : 'Reject'}
          cancelText="Cancel"
          loading={this.state.action_loading}
        >
          {this.state.confirmAction === 'reject' && (
            <div className="reject-note-container">
              <p>Please provide the reason for rejecting the refund process.</p>
              <textarea
                id="rejectNote"
                value={this.state.rejectNote || ''}
                onChange={(e) => {
                  const value = e.target.value;
                  this.setState({
                    rejectNote: value,
                    rejectNoteError: value.trim() === '' ? 'Reject note is required.' : null,
                  });
                }}
                placeholder="Enter reason for rejection"
                rows={3}
                className={`reject-note-textarea ${this.state.rejectNoteError ? 'is-invalid' : ''}`}
              />
              {this.state.rejectNoteError && (
                <p className="error-text">{this.state.rejectNoteError}</p>
              )}
            </div>
          )}
          {this.state.confirmAction === 'approve' && (
            <p className="modal-message">Are you sure you want to approve this item?</p>
          )}
        </ConfirmModal>
        <ConfirmModal
          show={this.state.showUserPopUp}
          onClose={() => this.setState({ showUserPopUp: false })}
          title="Account Information"
          closeBtn={true}
        >
          <UserProfileContent user={this.state.selectedUser} />
        </ConfirmModal>
      </React.Fragment>
    );
  }
}
const UserProfileContent = ({ user }) => {
  return (
    <div className="user-profile-container">
      <div className="profile-header">
        <div className="profile-avatar">{user.name ? user.name.charAt(0) : 'U'}</div>
        <div>
          <h3 className="profile-name">{user.name || 'User Profile'}</h3>
          <p className="profile-subtitle">Account Information</p>
        </div>
      </div>

      {/* Your existing profile items */}
      <div className="profile-item">
        <User size={18} className="profile-icon" />
        <span>
          <strong>Name</strong> {user.name || '-'}
        </span>
      </div>
      <div className="profile-item">
        <Mail size={18} className="profile-icon" />
        <span>
          <strong>Email</strong> {user.email || '-'}
        </span>
      </div>
      <div className="profile-item">
        <Phone size={18} className="profile-icon" />
        <span>
          <strong>Mobile</strong> {user.country_code || ''} {user.mobile || '-'}
        </span>
      </div>
      <div className="profile-item">
        <CreditCard size={18} className="profile-icon" />
        <span>
          <strong>Bank</strong> {user.bank || '-'}
        </span>
      </div>
      <div className="profile-item">
        <FileText size={18} className="profile-icon" />
        <span>
          <strong>Account Number</strong> {user.account_number || '-'}
        </span>
      </div>
      <div className="profile-item">
        <FileText size={18} className="profile-icon" />
        <span>
          <strong>Receipt Number</strong> {user.receipt_number || '-'}
        </span>
      </div>
    </div>
  );
};
